var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_194",
    "data-name": "Grupo 194",
    transform: "translate(-1210 -18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_2",
    "data-name": "Elipse 2",
    transform: "translate(1210 18)",
    fill: "none",
    stroke: "#122866",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-exit-to-app",
    "data-name": "Icon material-exit-to-app",
    d: "M11.65,17.2l1.422,1.422,5.042-5.042L13.072,8.534,11.65,9.956l2.6,2.612H4.5v2.017h9.752L11.65,17.2ZM20.636,4.5H6.517A2.016,2.016,0,0,0,4.5,6.517v4.034H6.517V6.517H20.636V20.636H6.517V16.6H4.5v4.034a2.016,2.016,0,0,0,2.017,2.017H20.636a2.023,2.023,0,0,0,2.017-2.017V6.517A2.023,2.023,0,0,0,20.636,4.5Z",
    transform: "translate(1216.424 24.424)",
    fill: "#122866",
    stroke: "#e9ebf5",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/logOut.c551f8daf9cdeb04349440c6a29fa6fd.svg";
export { ForwardRef as ReactComponent };